import React, { useEffect, useState } from "react";
import { fetchSystemLogs } from "../../api/systemLogService";

const Spinner = () => (
    <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
    </div>
);

const SystemLogViewer = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadLogs = async () => {
            try {
                const fetchedLogs = await fetchSystemLogs();

                setLogs(
                    Array.isArray(fetchedLogs)
                        ? fetchedLogs
                        : fetchedLogs?.data || []
                );
            } catch (error) {
                console.error(error);
                setError("Failed to load system logs");
            } finally {
                setLoading(false);
            }
        };

        loadLogs();
    }, []);

    if (loading) return <Spinner />;
    if (error) return <p className="text-red-500">{error}</p>;

    return (
        <div className="p-4 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">System Logs</h2>

            {logs.length === 0 ? (
                <p className="text-gray-500">No logs available.</p>
            ) : (
                <ul className="space-y-2">
                    {logs.map((log) => (
                        <li key={log.id} className="border-b pb-2">
                            <span className="text-gray-500 text-sm">
                                [{log.timestamp
                                    ? new Date(log.timestamp).toLocaleString()
                                    : "�"}]
                            </span>{" "}
                            <strong>{log.eventType || "Event"}</strong>:{" "}
                            {log.message || "No message"}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SystemLogViewer;